import { gql } from '@apollo/client';

export default gql`
  mutation deleteInspectionResult($id: ID!) {
    deleteInspectionResult(input: { id: $id }) {
      success
    }
  }
`;
